import {
    GET_GIFT_CARD_BALANCE,
    UPDATE_GIFT_CARD,
    SET_GIFT_CARD_ERROR,
} from '../actionTypes/CartActionTypes';

export const getGiftCardBalance = (payload) => ({
    type: GET_GIFT_CARD_BALANCE,
    payload,
});

export const updateGiftCard = (payload) => ({
    type: UPDATE_GIFT_CARD,
    payload,
});

export const setGiftCardError = (payload) => ({
    type: SET_GIFT_CARD_ERROR,
    payload,
});
